import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import EditorClient from '@/components/EditorClient'
import { apiClient } from '@/lib/api'

export const bussboardEditorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bussboard/$id',
  beforeLoad: async ({ params }) => {
    if (params.id === 'local-dev') return
    try {
      await apiClient.get('/api/v1/auth/me')
    } catch {
      throw redirect({ to: '/login' })
    }
  },
  component: BussboardEditorPage,
})

function BussboardEditorPage() {
  const { id } = bussboardEditorRoute.useParams()
  return <EditorClient id={id} />
}
